import { DownloadIcon } from "@/assets/icons";
import { Button } from "@/atoms";
import { ChatBox } from "@/components";
import { strings } from "@/constants";
import { ButtonVariantEnum, LanguageEnum } from "@/enums";
import type { ChatResultInterface } from "@/interfaces";
import type { LanguageType } from "@/types";

export const ResultChatView = ({
    isCopied,
    lang,
    onCopy,
    onDownload,
    onReset,
    result,
}: {
    isCopied: boolean,
    lang: LanguageType,
    onCopy: () => void,
    onDownload: () => void,
    onReset: () => void,
    result: ChatResultInterface,
}) => (
    <div
        className="
            mx-auto
            flex
            h-full
            w-full
            max-w-226.25
            flex-col
            gap-4
        "
    >
        <div className="min-h-0 flex-1">
            <ChatBox
                content={result.content}
                isCopied={isCopied}
                isRtl={lang === LanguageEnum.AR}
                userName={result.userName}
                onCopy={onCopy}
            />
        </div>
        <div
            className="
                flex
                shrink-0
                flex-col
                gap-4
                sm:flex-row
                sm:items-center
            "
        >
            <div
                className="
                    flex
                    items-center
                    gap-2
                    rounded-full
                    border-2
                    border-primary
                    bg-white
                    px-3
                    py-2
                    sm:flex-1
                    sm:px-4
                    sm:py-3
                "
            >
                <span
                    className="
                        flex-1
                        truncate
                        text-base
                        text-text-primary
                    "
                >
                    {result.code}
                </span>
                <span
                    className="
                        shrink-0
                        text-sm
                        font-medium
                        text-primary
                    "
                >
                    {`${strings.result.selectedLanguage} (${lang === LanguageEnum.AR ? strings.common.languageAr : strings.common.languageEn})`}
                </span>
            </div>
            <Button
                className="
                    inline-flex
                    items-center
                    justify-center
                    gap-2
                "
                variant={ButtonVariantEnum.PRIMARY}
                onClick={onDownload}
            >
                <DownloadIcon className="size-4" />
                {strings.result.pdfButton}
            </Button>
            <Button onClick={onReset}>
                {strings.result.buttonReset}
            </Button>
        </div>
    </div>
);
